import { getCurpValidationError, getRfcValidationError } from "../../../common/functions";

interface HireMegaMovilValidationParams {
    showCurp: boolean;
    curp: string;
    showBusinessFields: boolean;
    socialReasonType: string;
    rfc: string;
    cantidad: string;
}

const MIN_QUANTITY_TO_HIRE = 1;

export const getHireMegaMovilValidationError = ({
    showCurp,
    curp,
    showBusinessFields,
    socialReasonType,
    rfc,
    cantidad,
}: HireMegaMovilValidationParams): string | null => {
    if (showCurp) {
        const validationError = getCurpValidationError(curp);
        if (validationError) {
            return validationError;
        }
    }

    if (showBusinessFields && !socialReasonType) {
        return "Selecciona el tipo de razón social.";
    }

    if (showBusinessFields) {
        const validationErrorRFC = getRfcValidationError(rfc);
        if (validationErrorRFC) {
            return validationErrorRFC;
        }
    }

    if (cantidad === "" || Number.parseInt(cantidad, 10) < MIN_QUANTITY_TO_HIRE) {
        return `Debes ingresar una cantidad válida, la mínima es ${MIN_QUANTITY_TO_HIRE}.`;
    }

    return null;
};
